export const PENDING = 0;
export const PROCESS = 1;
export const FINISHED = 2;
export const ERROR = 3;

export const TYPE_USER = 1;
export const TYPE_BOT = 0;

export const GEMINI_PRO_MODEL = 1;
